var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg4Selected = function Svg4Selected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 150,
    viewBox: "0 0 100 150",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2783",
    "data-name": "Group 2783",
    transform: "translate(-496 -610)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2141",
    "data-name": "Group 2141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2140",
    "data-name": "Group 2140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1119",
    "data-name": "Rectangle 1119",
    transform: "translate(496 610)",
    fill: "#fff",
    stroke: "#7e6f68",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 150,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 149,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1120",
    "data-name": "Rectangle 1120",
    transform: "translate(505 620)",
    fill: "#fff",
    stroke: "#7e6f68",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1199",
    "data-name": "Rectangle 1199",
    transform: "translate(505 672)",
    fill: "#fff",
    stroke: "#7e6f68",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1191",
    "data-name": "Rectangle 1191",
    transform: "translate(550 620)",
    fill: "#fff",
    stroke: "#7e6f68",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1198",
    "data-name": "Rectangle 1198",
    transform: "translate(550 672)",
    fill: "#fff",
    stroke: "#7e6f68",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1156",
    "data-name": "Rectangle 1156",
    width: 35,
    height: 1,
    transform: "translate(505 660)",
    fill: "#7e6f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1195",
    "data-name": "Rectangle 1195",
    width: 35,
    height: 1,
    transform: "translate(505 712)",
    fill: "#7e6f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1192",
    "data-name": "Rectangle 1192",
    width: 35,
    height: 1,
    transform: "translate(550 660)",
    fill: "#7e6f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1196",
    "data-name": "Rectangle 1196",
    width: 35,
    height: 1,
    transform: "translate(550 712)",
    fill: "#7e6f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1158",
    "data-name": "Rectangle 1158",
    width: 35,
    height: 1,
    transform: "translate(505 666)",
    fill: "#7e6f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1194",
    "data-name": "Rectangle 1194",
    width: 35,
    height: 1,
    transform: "translate(505 718)",
    fill: "#7e6f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1193",
    "data-name": "Rectangle 1193",
    width: 35,
    height: 1,
    transform: "translate(550 666)",
    fill: "#7e6f68"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1197",
    "data-name": "Rectangle 1197",
    width: 35,
    height: 1,
    transform: "translate(550 718)",
    fill: "#7e6f68"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": 4,
    transform: "translate(537 745)",
    fill: "#7e6f68",
    fontSize: 24,
    fontFamily: "HelveticaNeue, Helvetica Neue",
    letterSpacing: "0.2em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4")))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg4Selected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/4-selected.371c0a7d.svg";
export { ForwardRef as ReactComponent };